<div *ngIf="showSpinner" class="spinner-container">
  <mat-spinner></mat-spinner>
</div>
<mat-list>
  <mat-list-item *ngFor="let author of (authorsList | async)">
    <button mat-button (click)="router.navigate(['/author/' + author.slug])" [ngClass]="{'selected-author': author.id === author_id}">
    {{ author.name}}
    </button>
  </mat-list-item>
</mat-list>
